/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_FilterInputs */

const he_search_filter = /** @type {(inputs: Search_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סינון`)
};

const en_search_filter = /** @type {(inputs: Search_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Search_FilterInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const search_filter = /** @type {((inputs?: Search_FilterInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_FilterInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_search_filter(inputs)
	return en_search_filter(inputs)
});